/* eslint-disable camelcase */
import React, { useState, useEffect, useMemo, useRef } from "react";
import "./AddService.css";

import { Splide, SplideSlide } from "@splidejs/react-splide";
import "@splidejs/react-splide/css";

import Cookies from "js-cookie";
import dayjs from "dayjs";
import axios from "axios";
import { Modal, ProgressBar, Spinner } from "react-bootstrap";


import {
  VisaForm,
  InsuranceForm,
  IDLForm,
  FlightsForm,
  CruisesForm,
  ToursForm,
  RentalCarsForm,
  EuroRailForm,
  PrivateJetForm,
  DefaultForm,
} from "../../../ServicesForms";
import { useTranslation } from "../../../../contexts/TranslationContext";
import { fromApi } from "./ServicesFromApiMapper";
import {
  buildVisaPayload,
  buildInsurancePayload,
  buildIDLPayload,
  buildFlightPayload,
  buildCruisesPayload,
  buildToursPayload,
  buildRentalCarsPayload,
  buildPrivateJetPayload,
  buildEuroRailPayload
} from "./ServicesPayloadBuilders";

import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { ErrorPopUp,TravelerSelector } from "../../../../components";
/* ─────────────────────────────────────────────── 1. Tabs  */
const allTabs = [
  { key: "visaInfo", label: "Visa" , label_translation: "Visa"},
  { key: "insurance", label: "Insurance" ,label_translation:"Insurance" },
  { key: "IDL", label: "IDL",label_translation:"IDL" },
  { key: "flight", label: "Flight",label_translation:"Flight" },
  { key: "Cruise", label: "Cruise",label_translation:"Cruise" },
  { key: "Tours", label: "Tours" ,label_translation:"Tours"},
  { key: "rentalCars", label: "Rental Cars" ,label_translation:"RentalCars"},
  { key: "privateJet", label: "Private Jet",label_translation:"PrivateJet" },
  { key: "euroRail", label: "Euro Rail",label_translation:"EuroRail" },
];

const typeMap = {
  visaInfo: "Visa",
  insurance: "Insurance",
  IDL: "IDL",
  flight: "Flight",
  Cruise: "Cruise",
  Tours: "Tours",
  rentalCars: "Rental Cars",
  privateJet: "Private Jet",
  euroRail: "Euro Rail",
};

const apiRequestService ="https://viaggioerp.inter-netsys.com/api/method/erpnext.selling.doctype.quotation.quotation.create_one_component_package";

/* ─────────────────────────────────────────────── 2. API endpoints */
const apiCreate = {
  visaInfo:
    "https://viaggioerp.inter-netsys.com/api/method/alltimes.alltimes_travel.doctype.visa_reservation.visa_reservation.set_visa_reservation",
  insurance:
    "https://viaggioerp.inter-netsys.com/api/method/alltimes.alltimes_travel.doctype.insurance_reservation.insurance_reservation.create_insurance_reservation",
  IDL: "https://viaggioerp.inter-netsys.com/api/method/alltimes.alltimes_travel.doctype.idl_reservation.idl_reservation.create_idl_reservation",
  flight:
    "https://viaggioerp.inter-netsys.com/api/method/alltimes.alltimes_travel.doctype.flight_reservation.flight_reservation.create_flight_reservation",
  Cruise:
    "https://viaggioerp.inter-netsys.com/api/method/alltimes.alltimes_travel.doctype.cruise_reservation.cruise_reservation.create_cruise_reservation",
  Tours:
    "https://viaggioerp.inter-netsys.com/api/method/alltimes.alltimes_travel.doctype.tour_reservation.tour_reservation.create_tour_reservation",
  rentalCars:
    "https://viaggioerp.inter-netsys.com/api/method/alltimes.alltimes_travel.doctype.rental_cars_reservation.rental_cars_reservation.create_rental_car",
  privateJet:
    "https://viaggioerp.inter-netsys.com/api/method/alltimes.alltimes_travel.doctype.private_jet_reservation.private_jet_reservation.create_private_jet_reservation",
  euroRail:
    "https://viaggioerp.inter-netsys.com/api/method/alltimes.alltimes_travel.doctype.euro_rail_reservation.euro_rail_reservation.create_euro_rail_reservation",


  };
const apiUpdate = {
  visaInfo:
    "https://viaggioerp.inter-netsys.com/api/method/alltimes.alltimes_travel.doctype.visa_reservation.visa_reservation.update_visa_reservation",
  insurance:
    "https://viaggioerp.inter-netsys.com/api/method/alltimes.alltimes_travel.doctype.insurance_reservation.insurance_reservation.update_insurance_reservation",
  IDL: "https://viaggioerp.inter-netsys.com/api/method/alltimes.alltimes_travel.doctype.idl_reservation.idl_reservation.update_idl_reservation",
  flight:
    "https://viaggioerp.inter-netsys.com/api/method/alltimes.alltimes_travel.doctype.flight_reservation.flight_reservation.update_flight_reservation",
  Cruise:
    "https://viaggioerp.inter-netsys.com/api/method/alltimes.alltimes_travel.doctype.cruise_reservation.cruise_reservation.update_cruise_reservation",
  Tours:
    "https://viaggioerp.inter-netsys.com/api/method/alltimes.alltimes_travel.doctype.tour_reservation.tour_reservation.update_tour_reservation",
  rentalCars:
    "https://viaggioerp.inter-netsys.com/api/method/alltimes.alltimes_travel.doctype.rental_cars_reservation.rental_cars_reservation.update_rental_car",
  privateJet:
    "https://viaggioerp.inter-netsys.com/api/method/alltimes.alltimes_travel.doctype.private_jet_reservation.private_jet_reservation.update_private_jet_reservation",
  euroRail:
    "https://viaggioerp.inter-netsys.com/api/method/alltimes.alltimes_travel.doctype.euro_rail_reservation.euro_rail_reservation.update_euro_rail_reservation",

  };
const apiGet = {
  visaInfo:
    "https://viaggioerp.inter-netsys.com/api/method/alltimes.alltimes_travel.doctype.visa_reservation.visa_reservation.get_visa_reservation_data?name=",
  insurance:
    "https://viaggioerp.inter-netsys.com/api/method/alltimes.alltimes_travel.doctype.insurance_reservation.insurance_reservation.get_insurance_reservation_data?name=",
  IDL: "https://viaggioerp.inter-netsys.com/api/method/alltimes.alltimes_travel.doctype.idl_reservation.idl_reservation.get_idl_reservation?name=",
  flight:
    "https://viaggioerp.inter-netsys.com/api/method/alltimes.alltimes_travel.doctype.flight_reservation.flight_reservation.get_flight_reservation_data?name=",
  Cruise:
    "https://viaggioerp.inter-netsys.com/api/method/alltimes.alltimes_travel.doctype.cruise_reservation.cruise_reservation.get_cruise_reservation_data?name=",
  Tours:
    "https://viaggioerp.inter-netsys.com/api/method/alltimes.alltimes_travel.doctype.tour_reservation.tour_reservation.get_tour_reservation_data?name=",
  rentalCars:
    "https://viaggioerp.inter-netsys.com/api/method/alltimes.alltimes_travel.doctype.rental_cars_reservation.rental_cars_reservation.get_rental_car?name=",
  privateJet:
    "https://viaggioerp.inter-netsys.com/api/method/alltimes.alltimes_travel.doctype.private_jet_reservation.private_jet_reservation.get_private_jet_reservation?name=",
  euroRail:
    "https://viaggioerp.inter-netsys.com/api/method/alltimes.alltimes_travel.doctype.euro_rail_reservation.euro_rail_reservation.get_euro_rail_reservation_data?name=",

  };

/* ─────────────────────────────────────────────── 3. Helpers */
const shortDate = (v) => (v ? dayjs(v).format("YYYY-MM-DD") : "");

/* ─────────────────────────────────────────────── 4. Component */
const AddService = ({
  url,
  quotationId,
  selectedDestination,
  selectedDates,
  editingComponent, // {component_id, component_type}
  onSubmit = () => {},
  onNext = () => {},
  onUpdateQuot = () => {},
  onReturn = () => {},
  selectedServices = [],
  initialFlight,
  setItems,
  fromService 
}) => {
  const visaFormRef = useRef();
  const insuranceFormRef = useRef();
  const idlFormRef = useRef();
  const flightFormRef = useRef();
  const cruiseFormRef = useRef();
  const toursFormRef = useRef();
  const rentalCarsFormRef = useRef();
  const privateJetFormRef = useRef();
  const euroRailFormRef = useRef();
  const defaultFormRefs = useRef({});
  const { t } = useTranslation();
  const Lang = Cookies.get("preferred_language") || "en";
  const [saving, setSaving] = useState(false);
  /* A. TABs */
  const [errorPopup, setErrorPopUp] = useState(null);
  const [travelers, setTravelers] = useState({ adults: 1, children: 0, infants: 0 });
//   children_num
//   adult_num
//   infant_num

// ages
// : 
// [3]
// 0
// : 
// 3

  const formRefs = {
    visaInfo: visaFormRef,
    insurance: insuranceFormRef,
    IDL: idlFormRef,
    flight: flightFormRef,
    Cruise: cruiseFormRef,
    Tours: toursFormRef,
    rentalCars: rentalCarsFormRef,
    privateJet: privateJetFormRef,
    defaultInfo: defaultFormRefs,
    euroRail: euroRailFormRef,
  };

  const filteredTabs = useMemo(() => {
    if (selectedServices.length === 0) return allTabs;

    // find matched tabs
    const matchedTabs = allTabs.filter((t) =>
      selectedServices.includes(t.label)
    );

    // find unmatched services
    const unmatchedServices = selectedServices.filter(
      (service) => !allTabs.some((t) => t.label === service)
    );

    // build default tabs for unmatched services
    const defaultTabs = unmatchedServices.map((service) => ({
      key: "default-" + service,
      label: service,
      label_translation:service
    }));

    return [...matchedTabs, ...defaultTabs];
    
  }, [selectedServices]);

  const isEditMode = editingComponent != null; // dic ths

  const selectedFlightId = initialFlight?.package_component_id || null;
  const [activeTab, setActiveTab] = useState(filteredTabs[0]?.key || "");
  const [completed, setCompleted] = useState({}); // {visaInfo:true,…}
  useEffect(() => {
    if (!filteredTabs.length) return;
    const exists = filteredTabs.some((t) => t.key === activeTab);
    if (!exists) setActiveTab(filteredTabs[0].key);
  }, [filteredTabs]);



  /* B. Forms state */
  const [formsData, setFormsData] = useState({}); // {visaInfo:{data,valid,docName}}
  const handleFormChange = (key, { data, valid }) =>
    setFormsData((p) => ({ ...p, [key]: { ...p[key], data, valid } }));

  /* C. Errors + upload progress */
  const [showErr, setShowErr] = useState({});
  const [globalErr, setGlobalErr] = useState("");
  const [uploads, setUploads] = useState([]);
  const [showModal, setShowModal] = useState(false);

  /* D. Helpers */
  const uploadFile = (file, onProgress) => {
    const apiKey = Cookies.get("api_key");
    const apiSecret = Cookies.get("api_secret");
    const fd = new FormData();
    fd.append("file", file);
    return axios
      .post("https://viaggioerp.inter-netsys.com/api/method/upload_file?", fd, {
        headers: {
          "Content-Type": "multipart/form-data",
          Authorization: `token ${apiKey}:${apiSecret}`,
        },
        onUploadProgress: (e) =>
          onProgress(Math.round((e.loaded * 100) / e.total)),
      })
      .then((r) => r.data?.message?.file_url || "");
  };

  const normalizeFiles = async (files = {}) => {
    const out = { ...files };
    const entries = Object.entries(files).filter(([, v]) => v instanceof File);
    if (!entries.length) return out;

    setUploads(
      entries.map(([k, f]) => ({ key: k, name: f.name, progress: 0 }))
    );
    setShowModal(true);

    await Promise.all(
      entries.map(([key, file]) =>
        uploadFile(file, (p) =>
          setUploads((u) =>
            u.map((x) => (x.key === key ? { ...x, progress: p } : x))
          )
        ).then((url) => {
          out[key] = url;
        })
      )
    );

    setShowModal(false);
    return out;
  };

  /* E. Save (Next / Finish) */
  const handleNext = async () => {
    setGlobalErr("");
    const curKey = activeTab; 
    const st = formsData[curKey];
    setShowErr((p) => ({ ...p, [curKey]: true }));

    if (!st?.valid) {
      // Scroll to first error in the current form
      const formRef = formRefs[curKey]?.current;
      if (formRef && formRef.scrollToFirstError) {
        formRef.scrollToFirstError();
      }
      return;
    }
    if (!curKey.includes("default-")) {
      // 1) upload files if any
      let localData = { ...st.data };

      try {
        localData.files = await normalizeFiles(localData.files);
      } catch {
        toast.error(t("uploadFailedTryAgain"), {
          position: "bottom-right",
        });
        setSaving(false);
        setShowModal(false);
        setGlobalErr(t("uploadFailedTryAgain"));
        setErrorPopUp(true);
        return;
      }

      // 2) minimal client‑side validations
      // if (curKey === "visaInfo" && !localData.files.bank) {
      //   setGlobalErr("Please upload the Bank Statement first.");
      //   setErrorPopUp(true);
      //   return;
      // }

      if (curKey === "flight" && !localData.files.passport_copy) {
        setGlobalErr(t("PleaseUploadThePassportCopyFirst"));
        setErrorPopUp(true);
        return;
      }

      if (
        curKey === "IDL" &&
        (!localData.files.passport_copy || !localData.files.license_copy)
      ) {
        setGlobalErr(t("PleaseUploadPassportDomesticLicenseCopiesFirst"));
        setErrorPopUp(true);
        return;
      }
      if (curKey === "Cruises" && !localData.files.passport_copy) {
        setGlobalErr(t("PleaseUploadPassportFirst"));
        setErrorPopUp(true);
        return;
      }
      if (curKey === "Tours" && !localData.files.passport_copy) {
        setGlobalErr(t("PleaseUploadThePassportCopyFirst"));
        setErrorPopUp(true);
        return;
      }

      // Add file validation if needed
      if (curKey === "rentalCars") {
        if (!localData.files.drivers_license_front) {
          setGlobalErr(t("PleaseUploadDriver'sLicense(Front)"));
          setErrorPopUp(true);
          return;
        }
        if (!localData.files.passport_copy) {
          setGlobalErr(t("PleaseUploadThePassportCopyFirst"));
          setErrorPopUp(true);
          return;
        }
      }

      if (curKey === "euroRail" && !localData.files.passport_copy) {
        setGlobalErr(t("PleaseUploadPassportFirst"));
        setErrorPopUp(true);
        return;
      }

      // 3) build payload

      setSaving(true);
      let payload = localData;
      if (curKey === "visaInfo")
        payload = buildVisaPayload(localData, quotationId);
      if (curKey === "Tours")
        payload = buildToursPayload(localData, quotationId);
      if (curKey === "insurance")
        payload = buildInsurancePayload(localData, quotationId);
      if (curKey === "IDL") payload = buildIDLPayload(localData, quotationId);
      if (curKey === "flight")
        payload = buildFlightPayload(localData, quotationId);
      if (curKey === "Cruise")
        payload = buildCruisesPayload(localData, quotationId);
      if (curKey === "rentalCars")
        payload = buildRentalCarsPayload(localData, quotationId);
      if (curKey === "privateJet")
        payload = buildPrivateJetPayload(localData, quotationId);
      if (curKey === "euroRail")
        payload = buildEuroRailPayload(localData, quotationId);
      const isUpdate = !!st?.docName; // true when editing
      if (isUpdate)
        payload = {
          name: st.docName,
          component_row_id: editingComponent.name,
          ...payload,
        };

      const apiKey = Cookies.get("api_key");
      const apiSecret = Cookies.get("api_secret");

      // 4) call backend
      const res = await fetch(
        isUpdate ? apiUpdate[curKey] : apiCreate[curKey],
        {
          method: isUpdate ? "PUT" : "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `token ${apiKey}:${apiSecret}`,
          },
          body: JSON.stringify(payload),
        }
      ).then((r) => r.json());
      
  
      if( res?.status_code === 200 || res?.status_code === "200"){
      /* ------------ success ------------- */
      const savedName = isUpdate ? st.docName : res?.result?.name;

      const val = { ...formsData[curKey], docName: savedName };
      const isFlight = curKey === "flight";

      let date_from = null;
      let date_to = null;

      if (typeMap[curKey] === "Cruise") {
        date_from = val.data.start_date
          ? dayjs(val.data.start_date).format("YYYY-MM-DD HH:mm:ss")
          : selectedDates?.startDate
          ? dayjs(selectedDates.startDate).format("YYYY-MM-DD HH:mm:ss")
          : null;
        date_to = val.data.end_date
          ? dayjs(val.data.end_date).format("YYYY-MM-DD HH:mm:ss")
          : selectedDates?.endDate
          ? dayjs(selectedDates.endDate).format("YYYY-MM-DD HH:mm:ss")
          : null;
      } else if (typeMap[curKey] === "Visa") {
        date_from = val.data.expected_travel
          ? dayjs(val.data.expected_travel).format("YYYY-MM-DD HH:mm:ss")
          : selectedDates?.startDate
          ? dayjs(selectedDates.startDate).format("YYYY-MM-DD HH:mm:ss")
          : null;
        date_to = val.data.expected_return
          ? dayjs(val.data.expected_return).format("YYYY-MM-DD HH:mm:ss")
          : selectedDates?.endDate
          ? dayjs(selectedDates.endDate).format("YYYY-MM-DD HH:mm:ss")
          : null;
      } else if (typeMap[curKey] === "IDL") {
        date_from = val.data.travel_start
          ? dayjs(val.data.travel_start).format("YYYY-MM-DD HH:mm:ss")
          : selectedDates?.startDate
          ? dayjs(selectedDates.startDate).format("YYYY-MM-DD HH:mm:ss")
          : null;
        date_to = val.data.travel_end
          ? dayjs(val.data.travel_end).format("YYYY-MM-DD HH:mm:ss")
          : selectedDates?.endDate
          ? dayjs(selectedDates.endDate).format("YYYY-MM-DD HH:mm:ss")
          : null;
      } else if (typeMap[curKey] === "Insurance") {
        date_from = val.data.travel_start
          ? dayjs(val.data.travel_start).format("YYYY-MM-DD HH:mm:ss")
          : selectedDates?.startDate
          ? dayjs(selectedDates.startDate).format("YYYY-MM-DD HH:mm:ss")
          : null;
        date_to = val.data.travel_end
          ? dayjs(val.data.travel_end).format("YYYY-MM-DD HH:mm:ss")
          : selectedDates?.endDate
          ? dayjs(selectedDates.endDate).format("YYYY-MM-DD HH:mm:ss")
          : null;
      } else if (
        typeMap[curKey] === "Rental Cars" ||
        typeMap[curKey] === "Private Jet"
      ) {
        date_from = val.data.pickup_date_and_time
          ? dayjs(val.data.pickup_date_and_time).format("YYYY-MM-DD HH:mm:ss")
          : selectedDates?.startDate
          ? dayjs(selectedDates.startDate).format("YYYY-MM-DD HH:mm:ss")
          : null;
        date_to = val.data.drop_off_date_and_time
          ? dayjs(val.data.drop_off_date_and_time).format("YYYY-MM-DD HH:mm:ss")
          : selectedDates?.endDate
          ? dayjs(selectedDates.endDate).format("YYYY-MM-DD HH:mm:ss")
          : null;
      } else if (typeMap[curKey] === "Tours") {
        date_from = val.data.preferredTourDate
          ? dayjs(val.data.preferredTourDate).format("YYYY-MM-DD HH:mm:ss")
          : selectedDates?.startDate
          ? dayjs(selectedDates.startDate).format("YYYY-MM-DD HH:mm:ss")
          : null;
        date_to = val.data.preferredTourDate
          ? dayjs(val.data.preferredTourDate).format("YYYY-MM-DD HH:mm:ss")
          : selectedDates?.endDate
          ? dayjs(selectedDates.endDate).format("YYYY-MM-DD HH:mm:ss")
          : null;
      } 
      else if (typeMap[curKey] === "Euro Rail") {
        date_from = val.data.departure_date
          ? dayjs(val.data.departure_date).format("YYYY-MM-DD HH:mm:ss")
          : selectedDates?.startDate
          ? dayjs(selectedDates.startDate).format("YYYY-MM-DD HH:mm:ss")
          : null;
        date_to = val.data.return_date
          ? dayjs(val.data.return_date).format("YYYY-MM-DD HH:mm:ss")
          : selectedDates?.endDate
          ? dayjs(selectedDates.endDate).format("YYYY-MM-DD HH:mm:ss")
          : null;
      }
      
      else if (isFlight) {
        date_from = val.data.departure_date
          ? dayjs(val.data.departure_date).format("YYYY-MM-DD HH:mm:ss")
          : selectedDates?.startDate
          ? dayjs(selectedDates.startDate).format("YYYY-MM-DD HH:mm:ss")
          : null;
        date_to = val.data.return_date
          ? dayjs(val.data.return_date).format("YYYY-MM-DD HH:mm:ss")
          : selectedDates?.endDate
          ? dayjs(selectedDates.endDate).format("YYYY-MM-DD HH:mm:ss")
          : null;
      }
      if (isUpdate) {
        setItems(res?.message?.result?.items ?? []);

        //This function is dynamically called by the backend after the update
        // onUpdateQuot(date_from, date_to).then((val) => {

        //   if (val === true) {
      
        //     setFormsData((p) => ({
        //       ...p,
        //       [curKey]: { ...localData, valid: true, docName: savedName },
        //     }));
      
        //     setCompleted((p) => ({ ...p, [curKey]: true }));
        //     setSaving(false);
        //       toast.success(t("UpdatedSuccessfully"), {
        //       position: "bottom-right",
        //       autoClose: 1000,
        //       onClose: () => {
        //         onReturn(); 
        //       },
        //     });
        //     // onReturn();
        //   }
        //   else{
        //     setSaving(false);
        //     return;
        //   }
         
        // });
        setFormsData((p) => ({
          ...p,
          [curKey]: { ...localData, valid: true, docName: savedName },
        }));
  
        setCompleted((p) => ({ ...p, [curKey]: true }));
        setSaving(false);
        toast.success(t("UpdatedSuccessfully"), {
          position: "bottom-right",
          autoClose: 1000,
          pauseOnHover: false, // ignore hover
          closeOnClick: true,
          onClose: () => {
            onReturn();
          },
        });
      } else {
        // Build the single item payload
        const item = {
          package_component_type: isFlight ? "Flight" : "Service",
          package_component_id: isFlight ? selectedFlightId : typeMap[curKey],
          reservation_type: `${
            typeMap[curKey] === "Tours"
              ? "Tour Reservation"
              : `${typeMap[curKey]} Reservation`
          }`,
          reservation_id: val.docName,
          destination_row_id: selectedDestination?.primary_destination_row_id,
          date_from,
          date_to,
          from_destination: isFlight
            ? initialFlight?.from_destination
            : selectedDestination?.location,
          to_destination: isFlight ? initialFlight?.to_destination : null,
        };

        // Replace with onNext to add an element separately to quotation
        // onSubmit([item]);
        onNext([item]).then((val) => {
          if(val === true){
            setFormsData((p) => ({
              ...p,
              [curKey]: { ...localData, valid: true, docName: savedName },
            }));
            setCompleted((p) => ({ ...p, [curKey]: true }));

            const curIdx1 = filteredTabs.findIndex((t) => t.key === curKey);

            if (curIdx1 < filteredTabs.length - 1) {
              setActiveTab(filteredTabs[curIdx1 + 1].key);
              setSaving(false);
              // return;
            } else {
              onReturn();
              setSaving(false);
              return;
            }
          }

        });

      }
      }
      else{
        if (res?.exc) {
          let msg = t("anErrorOccured");
          if (res._server_messages) {
            try {
              const messages = JSON.parse(res._server_messages);
              msg = messages ? JSON.parse(messages[0]).message : null;
              } catch {
            } finally {
              setSaving(false);
            }
          }
          setErrorPopUp(true);
          setGlobalErr(msg);
        }
        else if(res?.message){     
            setErrorPopUp(true);       
            setGlobalErr(res?.message);
        }
        setSaving(false);
        return;
      }

    } else {
      setSaving(true);

      const val = { ...formsData[curKey], docName: "Service" };
      let date_from = null;
      let date_to = null;

      date_from = val.data.start_date
        ? dayjs(val.data.start_date).format("YYYY-MM-DD HH:mm:ss")
        : selectedDates?.startDate
        ? dayjs(selectedDates.startDate).format("YYYY-MM-DD HH:mm:ss")
        : null;
      date_to = val.data.end_date
        ? dayjs(val.data.end_date).format("YYYY-MM-DD HH:mm:ss")
        : selectedDates?.endDate
        ? dayjs(selectedDates.endDate).format("YYYY-MM-DD HH:mm:ss")
        : null;

      const curIdx1 = filteredTabs.findIndex((t) => t.key === curKey);
      if (!isEditMode) {
        const item = {
          package_component_type: "Service",
          package_component_id: curKey.replace(/^default-/, ""),
          destination_row_id: selectedDestination?.primary_destination_row_id,
          date_from,
          date_to,
          from_destination: selectedDestination?.location,
          to_destination: null,
        };
      
        onNext([item]).then((val) => {
          if(val ===true){
            if (curIdx1 < filteredTabs.length - 1) {
              setActiveTab(filteredTabs[curIdx1 + 1].key);
              setSaving(false);
              // return;
            } else {
              onReturn();
              setSaving(false);
              return;
            }
          }
        });

      } else {


        onUpdateQuot(date_from, date_to).then((val) => {
          if (val === true) {
            setSaving(false);
            toast.success(t("UpdatedSuccessfully"), {
              position: "bottom-right",
              autoClose: 1000,
              pauseOnHover: false, // ignore hover
              closeOnClick: true,
              onClose: () => {
                onReturn();
              },
            });
          }
          else{
            setSaving(false);
            return;
          }
          
        });
      }
    }
  };


  const handleNextService = async () => {
   
    setGlobalErr("");
    const curKey = activeTab;
    const st = formsData[curKey];
    setShowErr((p) => ({ ...p, [curKey]: true }));

    if (!st?.valid) {
      // Scroll to first error in the current form
      const formRef = formRefs[curKey]?.current;
      if (formRef && formRef.scrollToFirstError) {
        formRef.scrollToFirstError();
      }
      return;
    }
    if (!curKey.includes("default-")) {
      // 1) upload files if any
      let localData = { ...st.data };

      try {
        localData.files = await normalizeFiles(localData.files);
      } catch {
        toast.error(t("uploadFailedTryAgain"), {
          position: "bottom-right",
        });
        setSaving(false);
        setShowModal(false);
        setGlobalErr(t("uploadFailedTryAgain"));
        setErrorPopUp(true);
        return;
      }

      // 2) minimal client‑side validations
      // if (curKey === "visaInfo" && !localData.files.bank) {
      //   setGlobalErr("Please upload the Bank Statement first.");
      //   setErrorPopUp(true);
      //   return;
      // }

      if (curKey === "flight" && !localData.files.passport_copy) {
        setGlobalErr(t("PleaseUploadThePassportCopyFirst"));
        setErrorPopUp(true);
        return;
      }

      if (
        curKey === "IDL" &&
        (!localData.files.passport_copy || !localData.files.license_copy)
      ) {
        setGlobalErr(t("PleaseUploadPassportDomesticLicenseCopiesFirst"));
        setErrorPopUp(true);
        return;
      }
      if (curKey === "Cruises" && !localData.files.passport_copy) {
        setGlobalErr(t("PleaseUploadPassportFirst"));
        setErrorPopUp(true);
        return;
      }
      if (curKey === "Tours" && !localData.files.passport_copy) {
        setGlobalErr(t("PleaseUploadThePassportCopyFirst"));
        setErrorPopUp(true);
        return;
      }

      // Add file validation if needed
      if (curKey === "rentalCars") {
        if (!localData.files.drivers_license_front) {
          setGlobalErr(t("PleaseUploadDriver'sLicense(Front)"));
          setErrorPopUp(true);
          return;
        }
        if (!localData.files.passport_copy) {
          setGlobalErr(t("PleaseUploadThePassportCopyFirst"));
          setErrorPopUp(true);
          return;
        }
      }

      if (curKey === "euroRail" && !localData.files.passport_copy) {
        setGlobalErr(t("PleaseUploadPassportFirst"));
        setErrorPopUp(true);
        return;
      }

      // 3) build payload

      setSaving(true);
      let payload = localData;
      if (curKey === "visaInfo")
        payload = buildVisaPayload(localData, null, true);
      if (curKey === "Tours")
        payload = buildToursPayload(localData, null, true);
      if (curKey === "insurance")
        payload = buildInsurancePayload(localData, null,true);
      if (curKey === "IDL") payload = buildIDLPayload(localData, null,true);
      if (curKey === "flight")
        payload = buildFlightPayload(localData, null,true);
      if (curKey === "Cruise")
        payload = buildCruisesPayload(localData, null,true);
      if (curKey === "rentalCars")
        payload = buildRentalCarsPayload(localData, null,true);
      if (curKey === "privateJet")
        payload = buildPrivateJetPayload(localData, null,true);
      if (curKey === "euroRail")
        payload = buildEuroRailPayload(localData, null,true);

      const apiKey = Cookies.get("api_key");
      const apiSecret = Cookies.get("api_secret");

      // 4) call backend
      const res = await fetch(apiCreate[curKey], {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `token ${apiKey}:${apiSecret}`,
        },
        body: JSON.stringify(payload),
      }).then((r) => r.json());
     

      if (res?.status_code === 200 || res?.status_code === "200") {
        /* ------------ success ------------- */
        const savedName = res?.result?.name;

        const val = { ...formsData[curKey], docName: savedName };
          // Build the single item payload
          const item = {
            component_type: "Service",
            component_id: typeMap[curKey],
            reservation_type: `${
              typeMap[curKey] === "Tours"
                ? "Tour Reservation"
                : `${typeMap[curKey]} Reservation`
            }`,
            reservation_id: val.docName,
            // travelers: travelers,
            adult_num: travelers.adults,
            children_num: travelers.children,
            infant_num: travelers.infants,
            ages: travelers.childrenAges || [],
          };
          

          // Replace with onNext to add an element separately to quotation
          // onSubmit([item]);

            try {
          
              const resCreateService = await fetch(apiRequestService, {
                method: "POST",
                headers: {
                  "Content-Type": "application/json",
                  Authorization: `token ${apiKey}:${apiSecret}`,
                },
                body: JSON.stringify(item),
              }).then((r) => r.json());

              

              
              // setFormsData((p) => ({ ...p, [curKey]: { data: {}, valid: false } }));
              // setSaving(false);         
              // onReturn();

              toast.success(t("AddedSuccessfully"), {
                position: "bottom-right",
                autoClose: 1000,
                pauseOnHover: false,
                closeOnClick: true,
                onClose: () => {
                  setFormsData((p) => ({
                    ...p,
                    [curKey]: { ...localData, valid: true, docName: savedName },
                  }));
                  setCompleted((p) => ({ ...p, [curKey]: true }));
                  setSaving(false);

                  onReturn();
                },
              });
            } catch (err) {
  
              console.error(t("FailedToCreateServicePleaseTryAgain"), err);
              setGlobalErr(t("FailedToCreateServicePleaseTryAgain"));
              setErrorPopUp(true);
              setSaving(false);
            }
          
        
      } else {
        if (res?.exc) {
          let msg = t("anErrorOccured");
          if (res._server_messages) {
            try {
              const messages = JSON.parse(res._server_messages);
              msg = messages ? JSON.parse(messages[0]).message : null;
            } catch {
            } finally {
              setSaving(false);
            }
          }
          setErrorPopUp(true);
          setGlobalErr(msg);
        } else if (res?.message) {
          setErrorPopUp(true);
          setGlobalErr(res?.message);
        }
        setSaving(false);
        return;
      }
    }
  };
  

  /* F. Edit‑mode: fetch data ONCE */
  useEffect(() => {
    if (!editingComponent) return; // add‑mode

    var tabKey = null;
    if (editingComponent.service_has_form === 0) {
      tabKey = "default-" + editingComponent.package_component_id;
      setActiveTab(tabKey);
      setFormsData({
        [tabKey]: {
          data: {
            start_date: editingComponent.date_from,
            end_date: editingComponent.date_to,
          },
          valid: true,
          docName: editingComponent.package_component_id,
        },
      });
    } else {
      const ct = (editingComponent.package_component_id || "").toLowerCase();
      tabKey = ct.includes("visa")
        ? "visaInfo"
        : ct.includes("insurance")
        ? "insurance"
        : ct.includes("idl")
        ? "IDL"
        : ct.includes("flight")
        ? "flight"
        : ct.includes("cruise")
        ? "Cruise"
        : ct.includes("tour")
        ? "Tours"
        : ct.includes("rental")
        ? "rentalCars"
        : ct.includes("private")
        ? "privateJet"
        :ct.includes("euro")
        ? "euroRail"
        : "flight";
      setActiveTab(tabKey);
      const fetchOnce = async () => {
        const apiKey = Cookies.get("api_key");
        const apiSecret = Cookies.get("api_secret");
        const res = await fetch(
          apiGet[tabKey] + editingComponent.reservation_id,
          {
            headers: { Authorization: `token ${apiKey}:${apiSecret}` },
          }
        ).then((r) => r.json());
        if(res.status_code === 200 || res.status_code === "200" ){
          const raw = Array.isArray(res.result) ? res.result[0] : res.result;
          const formData = fromApi(tabKey, raw);
          setFormsData({
            [tabKey]: {
              data: formData,
              valid: true,
              docName: editingComponent.reservation_id,
            },
          });
        };

        }

        fetchOnce();
    }
  }, [editingComponent]);

  /* G. Helpers */
  // isClickable changed by rawan to disable clicking on the previous
  const isClickable = (key) => key === activeTab;
  const isComplete = (key) => {
    const idx = filteredTabs.findIndex((t) => t.key === key);
    const activeIdx = filteredTabs.findIndex((t) => t.key === activeTab);

    // Only tabs strictly before the active tab are complete
    return idx < activeIdx;
  };

  // const isClickable = (key) => {
  //   if (key === activeTab) return true;
  //   const idx = filteredTabs.findIndex((t) => t.key === key);
  //   const activeIdx = filteredTabs.findIndex((t) => t.key === activeTab);
  //   if (idx <= activeIdx) return true;
  //   return filteredTabs.slice(0, idx).every((t) => completed[t.key]);
  // };

  const idlInitialData = useMemo(
    () => formsData.IDL?.data || null,
    [formsData.IDL?.docName]
  );

  const visaInitialData = useMemo(
    () => formsData.visaInfo?.data || null,
    [formsData.visaInfo?.docName]
  );

  const insuranceInitialData = useMemo(
    () => formsData.insurance?.data || null,
    [formsData.insurance?.docName]
  );

  const cruisesInitialData = useMemo(
    () => formsData.Cruise?.data || null,
    [formsData.Cruise?.docName]
  );

  const flightsInitialData = useMemo(
    () => formsData.flight?.data || null,
    [formsData.flight?.docName]
  );

  const toursInitialData = useMemo(
    () => formsData.Tours?.data || null,
    [formsData.Tours?.docName]
  );

  const rentalCarsInitialData = useMemo(
    () => formsData.rentalCars?.data || null,
    [formsData.rentalCars?.docName]
  );

  const privateJetInitialData = useMemo(
    () => formsData.privateJet?.data || null,
    [formsData.privateJet?.docName]
  );

  const euroRailInitialData = useMemo(
    () => formsData.euroRail?.data || null,
    [formsData.euroRail?.docName]
  );

  // const defaultInitialData = useMemo(() => {
  const lastTabKey = filteredTabs.at(-1)?.key;

  /* ─────────────────────────────────────────────── UI */
  return (
    <div className="hotel-form-container">
      <div className="filter-component-header" style={{ marginBottom: "30px" }}>
        <button className="hotel-form-backbtn" onClick={onReturn}>
          {Lang === "ar" ? (
            <>
              {t("BackToServices")}
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="22"
                height="22"
                viewBox="0 0 23 23"
                fill="none"
              >
                <path
                  d="M5.75 11.5H18.2083M5.75 11.5L9.58333 7.66671M5.75 11.5L9.58333 15.3334"
                  stroke="white"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
            </>
          ) : (
            <>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="22"
                height="22"
                viewBox="0 0 23 23"
                fill="none"
              >
                <path
                  d="M5.75 11.5H18.2083M5.75 11.5L9.58333 7.66671M5.75 11.5L9.58333 15.3334"
                  stroke="white"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
              {t("Back To Services")}
            </>
          )}
        </button>
      </div>

      {/* title */}
      <div className="add-service-form-title">
        <div className="add-service-form-title-icon">
          {activeTab === "flight" ? (
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="14"
              height="14"
              viewBox="0 0 14 14"
              fill="none"
            >
              <path
                d="M13.6369 0.35708C14.121 0.841395 14.121 1.62123 13.6369 2.09733L10.4451 5.29053L12.1846 12.8344L11.0277 14L7.8441 7.90091L4.6441 11.1023L4.93949 13.1299L4.06154 14L2.61744 11.3896L0 9.93668L0.869744 9.05013L2.92103 9.35385L6.09641 6.17707L0 2.96746L1.16513 1.81003L8.70564 3.55028L11.8974 0.35708C12.3569 -0.119027 13.1774 -0.119027 13.6369 0.35708Z"
                fill="#27346A"
              />
            </svg>
          ) : (
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="18"
              height="18"
              viewBox="0 0 18 18"
              fill="none"
            >
              <path
                d="M12.0933 1.40625V2.19712C11.6319 2.27554 11.1938 2.45579 10.8108 2.72475L10.2303 2.17913L9.45689 3.006L10.0194 3.53306C9.7627 3.90842 9.58879 4.33409 9.5092 4.78181H8.71833V5.90681H9.5092C9.59133 6.37369 9.77583 6.79894 10.0368 7.17244L9.43889 7.75181L10.2489 8.56181L10.8283 7.96331C11.2018 8.22431 11.627 8.40881 12.0939 8.49094V9.28125H13.2189V8.49038C13.6666 8.41096 14.0922 8.23724 14.4676 7.98075L14.9941 8.54325L15.821 7.76925L15.2754 7.18987C15.5398 6.813 15.7198 6.37706 15.803 5.90625H16.5933V4.78125H15.8025C15.7216 4.32575 15.5415 3.89364 15.2748 3.51562L15.8025 2.988L15.011 2.19712L14.484 2.72475C14.1059 2.45807 13.6738 2.27793 13.2183 2.19712V1.40625H12.0933ZM12.6558 3.26981C12.9287 3.26802 13.1992 3.32044 13.4517 3.42402C13.7042 3.5276 13.9335 3.68029 14.1265 3.87322C14.3195 4.06616 14.4723 4.29549 14.5759 4.54793C14.6796 4.80036 14.732 5.07087 14.7303 5.34375C14.7303 6.49969 13.8118 7.41825 12.6558 7.41825C11.4999 7.41825 10.5813 6.49969 10.5813 5.34375C10.5813 4.18781 11.4999 3.26925 12.6558 3.26925V3.26981ZM5.3602 6.59138L4.32408 7.01325L4.72795 8.03137C4.19037 8.35316 3.73813 8.7996 3.40945 9.333L2.4082 8.928L1.98633 9.96581L2.98758 10.3697C2.90858 10.674 2.86739 10.9868 2.86495 11.3012C2.86495 11.6218 2.91277 11.9346 2.98758 12.2327L1.98633 12.6377L2.4082 13.6744L3.40945 13.2694C3.73521 13.8097 4.18778 14.2625 4.72795 14.5884L4.32295 15.5897L5.36077 16.0116L5.76577 15.0103C6.07005 15.0893 6.38291 15.1305 6.69727 15.1329C7.01789 15.1329 7.33177 15.0851 7.62877 15.0103L8.03377 16.0116L9.07045 15.5897L8.66545 14.5884C9.1994 14.2605 9.646 13.8081 9.96708 13.2699L10.9852 13.6738L11.4071 12.6371L10.389 12.2321C10.4621 11.934 10.5116 11.6207 10.5116 11.3006C10.5116 10.98 10.4626 10.6661 10.3878 10.3686L11.4076 9.96469L10.9858 8.92688L9.96764 9.33187C9.64442 8.7999 9.19799 8.35347 8.66602 8.03025L9.07102 7.01213L8.0332 6.59025L7.62989 7.60838C7.32519 7.53061 7.01227 7.48963 6.69783 7.48631C6.3772 7.48631 6.06445 7.53469 5.76633 7.60894L5.36133 6.59081L5.3602 6.59138ZM6.6967 8.61188C8.19464 8.61188 9.38545 9.80437 9.38545 11.3017C9.38658 12.7997 8.19464 14.0085 6.6967 14.0085C6.34112 14.0089 5.98895 13.9392 5.66035 13.8034C5.33175 13.6675 5.03318 13.4681 4.78175 13.2167C4.53032 12.9653 4.33096 12.6667 4.19509 12.3381C4.05922 12.0095 3.98951 11.6573 3.98995 11.3017C3.98995 9.80381 5.19933 8.61188 6.6967 8.61188Z"
                fill="#27346A"
              />{" "}
            </svg>
          )}
        </div>
        <div>{activeTab === "flight" ? t("AddFlight") : t("AddServices")}</div>
      </div>

      {/* tabs */}
      <div className="add-services-tabs-scroll-wrapper">
        <Splide
          options={{
            type: "slide",
            gap: "1rem",
            pagination: false,
            arrows: false,
            drag: "free",
            autoWidth: true,
          }}
        >
          {filteredTabs.map((tab) => (
            <SplideSlide key={tab.key}>
              <div
                className={`tab-button ${
                  activeTab === tab.key ? "active" : ""
                } ${!isClickable(tab.key) ? "disabled" : ""}
                 ${isComplete(tab.key) ? "complete" : ""}
                
                `}
                onClick={() => {
                  if (isClickable(tab.key)) setActiveTab(tab.key);
                  // else setShowErr((p) => ({ ...p, [activeTab]: true }));
                }}
              >
                {t(tab.label_translation)}
              </div>
            </SplideSlide>
          ))}
        </Splide>
      </div>

      {/* content */}
      <div className="add-services-tab-content" style={{ marginTop: "1.5rem" }}>
        {activeTab === "visaInfo" && (
          <VisaForm
            key={formsData.visaInfo?.docName || "visa-new"}
            showErrors={!!showErr.visaInfo}
            onChange={(d, v) =>
              handleFormChange("visaInfo", { data: d, valid: v })
            }
            initialData={visaInitialData}
            selectedDates={selectedDates}
            selectedDestination={selectedDestination}
            onTravelersChange={setTravelers}
            ref={visaFormRef}
            url={url}
            />
        )}
        {activeTab === "insurance" && (
          <InsuranceForm
            url={url}
            key={formsData.insurance?.docName || "insurance-new"}
            showErrors={!!showErr.insurance}
            onChange={(d, v) =>
              handleFormChange("insurance", { data: d, valid: v })
            }
            initialData={insuranceInitialData}
            selectedDates={selectedDates}
            ref={insuranceFormRef}
          />
        )}
        {activeTab === "IDL" && (
          <IDLForm
            url={url}
            key={formsData.IDL?.docName || "idl-new"}
            showErrors={!!showErr.IDL}
            onChange={(d, v) => handleFormChange("IDL", { data: d, valid: v })}
            initialData={idlInitialData}
            selectedDates={selectedDates}
            ref={idlFormRef}
          />
        )}

        {activeTab === "flight" && (
          <FlightsForm
            url={url}
            key={formsData.flight?.docName || "flight-new"}
            showErrors={!!showErr.flight}
            onChange={(d, v) =>
              handleFormChange("flight", { data: d, valid: v })
            }
            selectedDates={selectedDates}
            initialData={flightsInitialData}
            flightFirstAdd={initialFlight}
            ref={flightFormRef}
          />
        )}
        {activeTab === "Cruise" && (
          <CruisesForm
            url={url}
            key={formsData.Cruise?.docName || "cruises-new"}
            showErrors={!!showErr.Cruise}
            onChange={(d, v) =>
              handleFormChange("Cruise", { data: d, valid: v })
            }
            initialData={cruisesInitialData}
            selectedDates={selectedDates}
            ref={cruiseFormRef}
          />
        )}
        {activeTab === "Tours" && (
          <ToursForm
            url={url}
            key={formsData.Tours?.docName || "tours-new"}
            showErrors={!!showErr.Tours}
            onChange={(d, v) =>
              handleFormChange("Tours", { data: d, valid: v })
            }
            initialData={toursInitialData}
            selectedDates={selectedDates}
            ref={toursFormRef}
          />
        )}
        {activeTab === "rentalCars" && (
          <RentalCarsForm
            url={url}
            key={formsData.rentalCars?.docName || "rental-new"}
            showErrors={!!showErr.rentalCars}
            onChange={(d, v) =>
              handleFormChange("rentalCars", { data: d, valid: v })
            }
            initialData={rentalCarsInitialData}
            selectedDates={selectedDates}
            ref={rentalCarsFormRef}
          />
        )}
        {activeTab === "privateJet" && (
          <PrivateJetForm
            url={url}
            key={formsData.privateJet?.docName || "private-new"}
            showErrors={!!showErr.privateJet}
            onChange={(d, v) =>
              handleFormChange("privateJet", { data: d, valid: v })
            }
            initialData={privateJetInitialData}
            selectedDates={selectedDates}
            ref={privateJetFormRef}
          />
        )}

        {activeTab === "euroRail" && (
          <EuroRailForm
            url={url}
            key={formsData.euroRail?.docName || "euro-new"}
            showErrors={!!showErr.euroRail}
            onChange={(d, v) =>
              handleFormChange("euroRail", { data: d, valid: v })
            }
            initialData={euroRailInitialData}
            selectedDates={selectedDates}
            ref={euroRailFormRef}
          />
        )}

        {![
          "visaInfo",
          "insurance",
          "IDL",
          "flight",
          "Flight",
          "Cruise",
          "Tours",
          "rentalCars",
          "privateJet",
          "euroRail",
        ].includes(activeTab) && (
          <DefaultForm
            url={url}
            key={formsData[activeTab]?.docName || `${activeTab}-new`}
            showErrors={!!showErr[activeTab]}
            onChange={(d, v) => {
              handleFormChange(activeTab, { data: d, valid: v });
            }}
            initialData={formsData[activeTab]?.data || null}
            ref={(el) => (defaultFormRefs.current[activeTab] = el)}
            selectedDates={selectedDates}
          />
        )}
        {globalErr && (
          <div className="field-error" style={{ marginTop: 16 }}>
            {globalErr}
          </div>
        )}
      </div>

      {/* footer */}
      <div className="add-services-footer-buttons">
        {/* <button className="btn-back" onClick={onReturn}>
          Back
        </button> */}
        <button
          className="btn-next"
          onClick={() => {
            if (fromService) {
              handleNextService();
            } else {
              handleNext();
            }
          }}
          disabled={saving}
        >
          {saving ? (
            <>
              <Spinner
                as="span"
                animation="border"
                size="sm"
                role="status"
                aria-hidden="true"
                className="me-2"
              />
              {isEditMode ? t("Updating…") : t("Saving…")}
            </>
          ) : activeTab === lastTabKey ? (
            isEditMode ? (
              t("Update")
            ) : (
              t("Finish")
            )
          ) : (
            t("NextAndSave")
          )}
        </button>
      </div>

      {/* upload modal */}
      <Modal centered show={showModal} backdrop="static" keyboard={false}>
        <Modal.Header>
          <Modal.Title>{t("uploadingFiles")}</Modal.Title>
        </Modal.Header>
        <Modal.Body style={{ maxHeight: 300, overflowY: "auto" }}>
          {uploads.map((u) => (
            <div key={u.key} style={{ marginBottom: 15 }}>
              <div className="d-flex justify-content-between mb-1">
                <small className="text-truncate" style={{ maxWidth: "85%" }}>
                  {u.name}
                </small>
                <small>{u.progress}%</small>
              </div>
              <ProgressBar now={u.progress} striped animated />
            </div>
          ))}
        </Modal.Body>
      </Modal>

      <ErrorPopUp
        message={globalErr}
        showpopUp={errorPopup}
        handleClose={() => {
          setErrorPopUp(false);
          setGlobalErr(null);
        }}
      />

      <ToastContainer
        position="bottom-right"
        hideProgressBar="true"
        type="error"
      />
    </div>
  );
};

export default AddService;
